var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000142886383558446599200000009369736450821066407_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M312,380c8.8,0,16-7.2,16-16V204c0-8.8-7.2-16-16-16s-16,7.2-16,16v160C296,372.8,303.2,380,312,380z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,380c8.8,0,16-7.2,16-16V204c0-8.8-7.2-16-16-16s-16,7.2-16,16v160C184,372.8,191.2,380,200,380z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,68c8.8,0,16-7.2,16-16s-7.2-16-16-16H192c-8.8,0-16,7.2-16,16s7.2,16,16,16H320z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,84c-8.8,0-16,7.2-16,16s7.2,16,16,16h16v294.4c0,36.2,29.4,65.6,65.6,65.6h188.8c36.2,0,65.6-29.4,65.6-65.6V116h16 c8.8,0,16-7.2,16-16s-7.2-16-16-16h-32H112H80z M384,116v294.4c0,18.6-15,33.6-33.6,33.6H161.6c-18.6,0-33.6-15-33.6-33.6V116H384 z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.b57f335b.svg";
export { ForwardRef as ReactComponent };